import { extendsDb } from '@/prisma/extends'
import { CacheOptions } from '@/prisma/extensions/cache'
import { PrismaClient } from '@prisma/client'

type HasModelMethods<T> = T extends { findUnique: Function } ? true : false

type AddWithCache<T> = T extends object
  ? T & {
      withCache(options: CacheOptions): T
    }
  : T

type AddWithCacheToModelDelegates<T> = {
  [K in keyof T]: HasModelMethods<T[K]> extends true ? AddWithCache<T[K]> : T[K]
}

type CustomPrismaClient = AddWithCacheToModelDelegates<PrismaClient>

const globalForPrisma = globalThis as unknown as {
  prisma?: CustomPrismaClient
}

let prisma: CustomPrismaClient

if (!globalForPrisma.prisma) {
  const client = new PrismaClient()
  if (typeof window === 'undefined') {
    // @ts-ignore
    prisma = await extendsDb(client)
    globalForPrisma.prisma = prisma
  } else {
    prisma = client as CustomPrismaClient
  }
} else {
  prisma = globalForPrisma.prisma
}

export default prisma
